export function applyAndroidWebViewClickFix() {
  try {
    const ua = navigator.userAgent || '';
    const isAndroid = /Android/.test(ua);
    const isDriverForm =
      (window.location.pathname || '').indexOf('/driver/form/') === 0;

    if (!isAndroid || !isDriverForm) return;

    const overlay = document.createElement('div');
    overlay.style.cssText = 'position:fixed;inset:0;z-index:9999;';

    overlay.addEventListener('click', function (e) {
      try {
        overlay.style.pointerEvents = 'none';
        const target = document.elementFromPoint(e.clientX, e.clientY);
        overlay.remove();
        if (target) {
          const opts = {
            bubbles: true,
            cancelable: true,
            clientX: e.clientX,
            clientY: e.clientY,
          };
          target.dispatchEvent(new MouseEvent('mousedown', opts));
          target.dispatchEvent(new MouseEvent('mouseup', opts));
          target.dispatchEvent(new MouseEvent('click', opts));
          if (target instanceof HTMLInputElement) {
            target.focus();
          }
        }
      } catch (err) {
        overlay.remove();
      }
    });
    document.body.appendChild(overlay);
  } catch (err) {
    // ignore error
  }
}
